var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"wrapper"},[_c('div',{staticClass:"input"},[_c('span',[_vm._v("\n      Cerca rifiuto\n    ")]),_vm._v(" "),_c('f7-icon',{staticClass:"icon",attrs:{"f7":"search","size":"24px","color":"primary"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }